import classNames from "classnames";
import { useTranslation } from "react-i18next";

import TextInput from "../../../components/forms/textInput";
import { IAbsherFormProps } from "../models";
import { OtpCodeForm } from "../otpCode/otpCodeForm";
// styles
import styles from "./profileInfo.module.scss";

export const AbsherStep = (props: IAbsherFormProps) => {
  const { onNationalIdChange, onOtpChange, isValidNationalId } = props;
  const { t } = useTranslation();

  const formSteps = {
    nationalId: {
      component: (
        <div className={classNames("mv1", styles.text_container)}>
          <TextInput
            id="absher"
            label={t("lbl_absher_input_label")}
            maxLength={10}
            handleChange={(e) => {
              onNationalIdChange(e.target.value);
            }}
          />
        </div>
      ),
    },
    otp: {
      component: <OtpCodeForm key={2} onChange={onOtpChange} />,
    },
  };

  return (
    <div className={styles.absher_container}>
      <div className={styles.absher_img_container}>
        <img alt="img" src="/assets/images/svg/absher.svg" />
      </div>
      {isValidNationalId
        ? formSteps.otp.component
        : formSteps.nationalId.component}
    </div>
  );
};
